import { render, staticRenderFns } from "./messageForm.vue?vue&type=template&id=9b2fd630&scoped=true"
import script from "./messageForm.vue?vue&type=script&lang=js"
export * from "./messageForm.vue?vue&type=script&lang=js"
import style0 from "./messageForm.vue?vue&type=style&index=0&id=9b2fd630&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2fd630",
  null
  
)

export default component.exports